import {
  DOC_CHECK_IN_TYPE,
  DOCUMENT_LOAD_STATUS,
  REFRESH_TOKEN_ACTION,
} from "../../../redux/constants/metaData";
import { isValidPlayload } from "../../../functions/reduxMethod";

export function shouldTriggerRefreshTokenPreAction(tokenRefreshPreActionInvoke) {
  if (!isValidPlayload(tokenRefreshPreActionInvoke)) {
    return false;
  }

  return (
    tokenRefreshPreActionInvoke.actionType === REFRESH_TOKEN_ACTION.checkinNew ||
    tokenRefreshPreActionInvoke.actionType ===
      REFRESH_TOKEN_ACTION.checkinNewViewCopy ||
    tokenRefreshPreActionInvoke.actionType ===
      REFRESH_TOKEN_ACTION.documentBasicInfoLoad ||
    tokenRefreshPreActionInvoke.actionType ===
      REFRESH_TOKEN_ACTION.logicalUnitsLoad ||
    tokenRefreshPreActionInvoke.actionType ===
      REFRESH_TOKEN_ACTION.recentlyUsedObjectsLoad ||
    tokenRefreshPreActionInvoke.actionType ===
      REFRESH_TOKEN_ACTION.advanceSearchObjectColumnssLoad ||
    tokenRefreshPreActionInvoke.actionType ===
      REFRESH_TOKEN_ACTION.advanceSearchObjectsLoad
  );
}

export function isCheckinInLoadingState(docCheckinType, checkinDocumentProgress) {
  if (docCheckinType === DOC_CHECK_IN_TYPE.checkinNew) {
    return (
      checkinDocumentProgress === DOCUMENT_LOAD_STATUS.onLoading ||
      checkinDocumentProgress === DOCUMENT_LOAD_STATUS.onViewCopyUpload ||
      checkinDocumentProgress === DOCUMENT_LOAD_STATUS.onDeleting
    );
  }

  return false;
}
